module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"probableConditions":"შესაძლო დაავადებათა ალბათობები","seeAll":"შეარჩიე"},"en":{"probableConditions":"Probable Conditions","seeAll":"See All"}}')
  delete Component.options._Ctor
}
